import React, { Component } from "react"
import { Row, Col, Card, CardBody } from "reactstrap"
import ReactApexChart from "react-apexcharts"
import axios from "axios"
import { connect } from "react-redux"
import config from "config/config"

class DeviceCategoryBreakdown extends Component {
  constructor(props) {
    super(props)

    this.state = {
      options: {
        chart: {
          type: "line",
          zoom: {
            enabled: true,
          },
          toolbar: {
            show: false, // ✅ Hide chart toolbar
          },
        },
        xaxis: {
          categories: [],
          title: {
            text: "Months",
          },
        },
        yaxis: {
          title: {
            text: "Visits",
          },
        },
        colors: ["#2990DF"], // ✅ Blue line color
        dataLabels: {
          enabled: true,
          style: {
            colors: ["#2990DF"], // Optional: blue data labels
          },
        },
        stroke: {
          curve: "smooth",
          width: 3,
        },
        markers: {
          size: 4,
          colors: ["#2990DF"],
          strokeColors: "#fff",
          strokeWidth: 2,
          hover: {
            size: 6,
          },
        },
        tooltip: {
          y: {
            formatter: val => `${val} visits`,
          },
        },
        grid: {
          borderColor: "#f1f1f1",
        },
      },
      series: [
        {
          name: "Visits",
          data: [],
        },
      ],
    }
  }

  componentDidMount() {
    this.fetchAnalyticsData()
  }

  fetchAnalyticsData = async () => {
    try {
      const { activeOrganization } = this.props
      const analyticsData = activeOrganization?.GoogleAnalyticsIntegrations[0]

      if (!analyticsData) {
        console.error("No Google Analytics Integration found")
        return
      }

      const response = await axios.get(
        `${config.backendUrl}/analytics/getReport?accessToken=${analyticsData.accessToken}&propertyId=${analyticsData.propertyId}&accountId=${analyticsData.accountId}`,
      )

      const data = response.data

      // Aggregate visits by month for the current year
      const currentYear = new Date().getFullYear()
      const monthlyData = Array(12).fill(0)

      data.rows.forEach(row => {
        const date = new Date(row.dimensionValues[1]?.value)
        const visits = Number(row.metricValues[0]?.value || 0)

        if (date.getFullYear() === currentYear) {
          const month = date.getMonth()
          monthlyData[month] += visits
        }
      })

      const totalVisits = monthlyData.reduce((a, b) => a + b, 0)

      this.setState({
        options: {
          ...this.state.options,
          xaxis: {
            ...this.state.options.xaxis,
            categories: [
              "Jan", "Feb", "Mar", "Apr", "May", "Jun",
              "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
            ],
          },
        },
        series: [
          {
            name: "Visits",
            data: monthlyData,
          },
        ],
        totalVisits,
      })
    } catch (error) {
      console.error("Error fetching Google Analytics data:", error)
    }
  }

  render() {
    const { totalVisits } = this.state

    return (
      <React.Fragment>
        <Card className="br">
          <CardBody>
            <h4 className="card-title mb-4">Current Year User Visits</h4>

            <Row className="text-center mt-4">
              <Col xs="12">
                <h5 className="font-size-20">{totalVisits}</h5>
                <p className="text-muted">Total Visits This Year</p>
              </Col>
            </Row>

            <div id="line-chart" className="chart-container" dir="ltr">
              <ReactApexChart
                options={this.state.options}
                series={this.state.series}
                type="line"
                height="350"
              />
            </div>
          </CardBody>
        </Card>
      </React.Fragment>
    )
  }
}

const mapStateToProps = state => ({
  activeOrganization: state.organizationReducer.activeOrganization,
})

export default connect(mapStateToProps)(DeviceCategoryBreakdown)
